import React, { useState } from "react";
import { string, shape, object } from "prop-types";
import get from "lodash/get";
import { collectionToStories, LazyCollection, Link } from "@quintype/components";
import { useSelector } from "react-redux";
import { getCollectionTemplate } from "../get-collection-template";
import { getLoadMoreStories } from "../utils";
import "./section.m.css";
import "../../arrow/components/Rows/OneBigThreeSmallSectionLayout/one-big-three-small-section-layout.m.css";
import { OneBigThreeSmallSectionLayout } from "../../arrow/components/Rows/OneBigThreeSmallSectionLayout";
import { StoryImageForSectionLayout } from "../../arrow/components/Rows/StoryImageForSectionLayout";
import BigSectionHeroImage from "../story-templates/big-section-hero-image";
import { getStoryBySection } from "../../../api/utils";
import useSimilarSections from "../../hook/useSimilarSections";
import { SeriesPageLayout } from "../../arrow/components/Rows/SeriesPageLayout";
import { MiscEpisodeListingLayout } from "../../arrow/components/Rows/MiscEpisodeListingLayout";

const SectionPage = (props) => {
  const isSeriePage = (props?.data?.isSeriesPage == "1");
  const isMiscEpisodesListingPage = (props?.data?.isMiscEpisodesListingPage == "1");

  if (isSeriePage) {
    return <SeriesPageLayout data={props.data} />
  }

  if (isMiscEpisodesListingPage) {
    return <MiscEpisodeListingLayout data={props.data} />
  }

  const [category, setCategory] = useState("");
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = get(qtState, ["currentPath"], "");

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

const cPathParts = currentPath?.split("/").filter(Boolean) || [];
const isChannelSubpath = cPathParts.length > 1;
const sectionTitleToUpcase = isChannelSubpath ? cPathParts[cPathParts.length - 1] : cPathParts[0] || "";
const sectionTitle = props?.data?.collection?.name ? capitalizeFirstLetter(props.data.collection.name) : capitalizeFirstLetter(sectionTitleToUpcase);

  const filterCategories = () => {
    if (currentPath !== "/all-tags") {
      return;
    }
    return (
      <div className="default-container">
        <div styleName="filter-title">Filter Options</div>
        <div styleName="filter-container">
          <div styleName="filter-group">
            <label htmlFor="category-a">By Category</label>
            <div onClick={() => setCategory("")} styleName="all-category">
              <p>All Category</p>
            </div>
          </div>
          <div styleName="filter-group">
            <label htmlFor="category-b">By Genre</label>
            <select id="category-b" value={category} onChange={(e) => setCategory(e.target.value)}>
              <option value="" disabled>
                Genre
              </option>
              <option value="genre-1">Genre 1</option>
              <option value="genre-2">Genre 2</option>
            </select>
          </div>
          <div styleName="filter-group">
            <label htmlFor="category-c">By Team</label>
            <select id="category-c" value={category} onChange={(e) => setCategory(e.target.value)}>
              <option value="" disabled>
                Production
              </option>
              <option value="tag-test">Production 1</option>
              <option value="production-tag-2">Production 2</option>
            </select>
          </div>
        </div>
      </div>
    );
  };
  // will be getting initially 9 items, but showing only 8 for loadmore functionality
  const adConfig = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "listing_page_ads"], {}));
  const qtConfig = useSelector((state) => get(state, ["qt", "config"], {}));
  const shouldUseCollection = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "should_use_collection"])
  );
  const [storiesToRender, setStoriesToRender] = useState(8);
  const [sectionPageStories, setStories] = useState(props.data.collection.items);
  const stories =
    (props.data.collection && props.data.collection.items && collectionToStories(props.data.collection)) || [];
  const noStoriesFound =
    props.pageType === "collection-page" ? "No Collection Stories Found" : "No Section Stories Found";
  /* if (stories.length === 0) {
    return <h1>{noStoriesFound}</h1>;
  }*/
  const childCollections = (get(props, ["data", "collection", "items"]) || []).filter(
    (item) => item.type === "collection" && item.items.length > 0
  );
  const collection = {
    items: !childCollections.length ? sectionPageStories.slice(0, storiesToRender) : props.data.collection.items,
  };
  const { data } = props;
  // avoid any edge-cases errors by any chance OneBigThreeSmallSectionLayout layout is triggered on any page
  let dataPullSimilarForSimilarSec = null;
  const storiesFromCollection = get(data, ["collection", "items"], []).filter((items) => items.type === "story") || [];
  const collectionItems = get(data, ["collection", "items"], []).filter((items) => items.type === "collection");
  const filteredCollection = category ? collectionItems.filter((item) => item.slug === category) : collectionItems;
  const behindPaywall=data.collection?.metadata?.["behind-paywall"]?.[0].name || null;
  const contentType= data.collection?.metadata?.["content-type"]?.[0].name || null;
  const ageRestriction = data.collection?.metadata?.["age-restriction"]?.[0].name || null;
  const collectionStory = {
    items: storiesFromCollection,
    name: data.collection.name,
    summary: data.collection.summary,
    datas: data,
    testFreeTextAttribute: data.collection?.metadata?.["similar-shows"]?.[0].name,
    behindPaywall,
    contentType
  };
  const collectionOfCollection = {
    items: collectionItems,
  };
  const getMoreStories = async (offset, limit) => {
    await getLoadMoreStories({
      offset: offset,
      limit: limit,
      slug: shouldUseCollection ? props.data.collection.slug : props.data.section.id,
      query: "section-id",
      shouldUseCollection: shouldUseCollection,
      setStories: setStories,
      storiesToRender: storiesToRender,
      setStoriesToRender: setStoriesToRender,
      stories: sectionPageStories,
      isSectionPage: true,
    });
  };
  const pageTitle =
    props.pageType === "collection-page"
      ? props.data.collection.name
      : `${props.data.section["display-name"] || props.data.section.name}`;
  return (
    <div styleName={!collectionItems.length > 0 && storiesFromCollection?.[0]?.story?.alternative ? "" : "container"}>
      <div styleName="main-contents">
        {filterCategories()}
        {collectionItems.length >= 1 ? (
          ((!currentPath.startsWith("/uusimmat")&&
          !currentPath.startsWith("/suosittua-nyt"))
        ) ? (
            <StoryImageForSectionLayout
              collection={{ ...props?.data?.collection, items: filteredCollection }}
              customCollectionName={sectionTitle}
            />
          ) : (
            ((!currentPath.startsWith("/uusimmat")&&
            !currentPath.startsWith("/suosittua-nyt"))?
            (<LazyCollection
              collection={{ items: filteredCollection }}
              collectionTemplates={getCollectionTemplate}
              lazyAfter={22}
            />):
            <OneBigThreeSmallSectionLayout
            oneCollectionData={dataPullSimilarForSimilarSec}
            childCollections={childCollections}
            collection={collectionStory}
            behindPaywall={behindPaywall}
            contentType={contentType}
            ageRestriction={ageRestriction}
          />)
          )
        ) : (
          collectionStory && (
            <OneBigThreeSmallSectionLayout
              oneCollectionData={dataPullSimilarForSimilarSec}
              childCollections={childCollections}
              collection={collectionStory}
              behindPaywall={behindPaywall}
              contentType={contentType}
              ageRestriction={ageRestriction}
            />
          )
        )}
        {/*<OneRowFiveColsVertical collection={childCollections}/>*/}
      </div>
      <div styleName="sidebar-contents"></div>
    </div>
  );
};
SectionPage.propTypes = {
  pageType: string,
  data: shape({
    collection: object,
    section: object,
    //etusivuChannelOneCollection: object,
    //etusivuChannelHomeCollection: object,
  }),
};
export { SectionPage };
